import * as React from 'react'

/**
 * Meta Pixel loader for the Gatsby LP. Renders nothing — the whole thing
 * runs in a client-only effect, so it's safe inside wrap-root.jsx (shared by
 * SSR and browser) without a hydration mismatch.
 *
 * Pixel ID is fetched at runtime from `/api/public/pixel` (same origin —
 * nginx proxies anything that isn't a static file to the Nuxt app that owns
 * the DB-backed admin setting) instead of baked in at build time, so a pixel
 * ID change in /admin/configuracoes takes effect without republishing the LP.
 */
export default function MetaPixel() {
  React.useEffect(() => {
    let cancelled = false

    fetch('/api/public/pixel')
      .then((res) => res.json())
      .then(({ pixelId }) => {
        if (cancelled || !pixelId || window.fbq) return

        /* eslint-disable */
        ;(function (f, b, e, v) {
          let n = (f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
          })
          if (!f._fbq) f._fbq = n
          n.push = n
          n.loaded = true
          n.version = '2.0'
          n.queue = []
          const t = b.createElement(e)
          t.async = true
          t.src = v
          const s = b.getElementsByTagName(e)[0]
          s.parentNode.insertBefore(t, s)
        })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
        /* eslint-enable */

        window.fbq('init', pixelId)
        window.fbq('track', 'PageView')
      })
      .catch(() => {})

    return () => {
      cancelled = true
    }
  }, [])

  return null
}
